import axios from 'axios'
import configs from '../configs'
import GenericDAO from './../generic-dao'

const failed = new Promise(resolve => { resolve(false) })

const findAll = (params) => GenericDAO.find(`/webcli/empresa/`, params)
const find = (id) => GenericDAO.find(`/webcli/empresa/${ id }/`)
const remove = (id) => GenericDAO.remove(`/webcli/empresa/${ id }/`)
const save = (dataSend) => GenericDAO.save(`/webcli/empresa/`, dataSend)


const toggle_status = (id, dataSend) => GenericDAO.save(`/webcli/empresa/${ id }/status/`, dataSend)
const adicionarCorrentista = (dataSend) => GenericDAO.save('/webcli/med-empresa-correntista/credenciar/', dataSend)
const excluirCorrentista = (dataSend) => GenericDAO.save(`/webcli/med-empresa-correntista/descredenciar/`, dataSend)
const buscarFaixa = (params) => GenericDAO.find(`/webcli/med-empresa-tabela-faixa/`, params)

const solicitarInclusaoCorrentista = (dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    let formData = new FormData()
    Object.keys(dataSend).forEach((key) => { if (dataSend[key]) formData.append(`${key}`, dataSend[key]) })

    return axios.post(
        `${ configs.baseUrl }/webcli/contratante/solicitar-inclusao-correntista/`, formData,
        { headers: {'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }` } }
    )
        .then(response => response)
        .catch(configs.errorHandler)
}

const solicitarExclusaoCorrentista = (dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    let formData = new FormData()
    Object.keys(dataSend).forEach((key) => { if (dataSend[key]) formData.append(`${key}`, dataSend[key]) })

    return axios.post(
        `${ configs.baseUrl }/webcli/contratante/solicitar-exclusao-correntista/`, formData,
        { headers: {'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }` } }
    )
        .then(response => response)
        .catch(configs.errorHandler)
}

const anexarTermo = (dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    let formData = new FormData()
    Object.keys(dataSend).forEach((key) => { if (dataSend[key]) formData.append(`${key}`, dataSend[key]) })

    return axios.patch(
        `${ configs.baseUrl }/webcli/contratante/anexar-comprovante-solicitacao/`, formData,
        { headers: {'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }` } }
    )
        .then(response => response)
        .catch(configs.errorHandler)
}

const inativarCorrentista = (dataSend) => GenericDAO.save(`/webcli/empresa/descredenciar-correntistas/`, dataSend, { ignorarEstabelecimento: true })
// const inativarCorrentista = (id, dataSend) => GenericDAO.save(`/webcli/empresa-associados/${id}/status/`, dataSend,  { ignorarEstabelecimento: true })
// visao do contratante das solicitacoes feitas pela contratante
const listarSolicitacaoContratante = (params) => GenericDAO.find('/webcli/contratante/solicitacoes/', params)
// visao do adm medclub das solicitacoes feitas pela contratante
const listarSolicitacaoContratanteMedclub = (params) => GenericDAO.find('/medclub/empresa-adm/listar-solicitacoes/', params)
// endpoint para aceitacao ou recusa de solicitacoes feitas pela contratante
const atualizarSolicitacaoContratanteMedclub =  (dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    const path = `/medclub/empresa-adm/atualizar-solicitacao/`
    return axios.patch(
        `${ configs.baseUrl }${path}`, dataSend, { headers: {
                'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }`
            } }
    )
        .then(response => response)
        .catch(configs.errorHandler)
}
const anexarComprovanteAprovarSolicitacao = (dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    let formData = {
        cd_solicitacao: dataSend.cd_solicitacao,
        aq_anexo: dataSend.aq_anexo
    }

    if (dataSend.aq_anexo) {
        formData = new FormData()
        formData.append('aq_anexo', dataSend.aq_anexo)
        formData.append('cd_solicitacao', dataSend.cd_solicitacao)
    }
    return axios.patch(
        `${ configs.baseUrl }/medclub/empresa-adm/anexar-comprovante-solicitacao/`, formData,
        { headers: {'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }` } }
    )
        .then(response => response)
    
}
// const inativarCorrentista = (id, dataSend) => {
//     let usuario = JSON.parse(localStorage.getItem('usuario'))
//     if (!usuario) return failed

//     const path = `/webcli/agendamento/${idHorario}/agendar-retorno${ force ? '-forcado' : ''}/`
//     return axios.patch(
//         `${ configs.baseUrl }${path}`, dataSend, { headers: {
//                 'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }`
//             } }
//     )
//         .then(response => response)
//         .catch(configs.errorHandler)
// }

const saveUsuario = (dataSend) => GenericDAO.save(`/webcli/empresa-usuarios/`, dataSend)
const historicoEmpresa = (id) => GenericDAO.find(`/webcli/empresa/${ id }/historico-status/`)
const historicoCorrentista = (id) => GenericDAO.find(`/webcli/empresa-associados/${ id }/historico-status/`)

// const saveContrato = (dataSend) => GenericDAO.save(`/webcli/med-empresa/contrato/`, dataSend)
// const findAllContrato = (params) => GenericDAO.find(`/webcli/med-empresa-contrato/`, params)

const saveContrato = (dataSend, metodo) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    let formData = {}
    console.log(dataSend.aq_anexo)
    formData = new FormData()
    if(dataSend.id) formData.append('id', dataSend.id)
    if(dataSend.aq_anexo[0]) formData.append('aq_anexo', dataSend.aq_anexo[0]) 
    if(dataSend.cd_empresa)formData.append('cd_empresa', dataSend.cd_empresa)
    if(dataSend.ds_contrato)formData.append('ds_contrato', dataSend.ds_contrato)
    if(dataSend.ds_observacao) formData.append('ds_observacao', dataSend.ds_observacao)
    if(dataSend.dt_vigencia_final) formData.append('dt_vigencia_final', dataSend.dt_vigencia_final)
    if(dataSend.dt_vigencia_inicial)formData.append('dt_vigencia_inicial', dataSend.dt_vigencia_inicial)
    if(dataSend.ie_contempla_dependentes)formData.append('ie_contempla_dependentes', dataSend.ie_contempla_dependentes)
    if(dataSend.ie_tipo_contrato)formData.append('ie_tipo_contrato', dataSend.ie_tipo_contrato)
    if(dataSend.ie_tipo_valor)formData.append('ie_tipo_valor', dataSend.ie_tipo_valor)
    if(dataSend.nr_dia_vencimento_mensalidade)formData.append('nr_dia_vencimento_mensalidade', dataSend.nr_dia_vencimento_mensalidade)
    if(dataSend.nr_dia_vencimento_resgate)formData.append('nr_dia_vencimento_resgate', dataSend.nr_dia_vencimento_resgate)
    if(dataSend.nr_dia_vencimento_taxa)formData.append('nr_dia_vencimento_taxa', dataSend.nr_dia_vencimento_taxa)
    if(dataSend.nr_percentual_intermediacao)formData.append('nr_percentual_intermediacao', dataSend.nr_percentual_intermediacao)
    if(dataSend.nr_valor_intermediacao)formData.append('nr_valor_intermediacao', (dataSend.nr_valor_intermediacao))
    if(dataSend.responsavel)formData.append('responsavel', JSON.stringify(dataSend.responsavel))
    if(dataSend.vl_mensalidade)formData.append('vl_mensalidade', dataSend.vl_mensalidade)

    return axios[metodo](
        `${ configs.baseUrl }/webcli/med-empresa-contrato/${metodo == 'patch' ? `${dataSend.id}/` : ''}`, formData,
        { headers: {'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }` } }
    )
        .then(response => response)
        .catch(configs.errorHandler)
}


const adicionarCorrentistasArquivo = (dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    let formData = {}
    
        formData = new FormData()
        formData = new FormData()
        formData.append('file', dataSend.file)
    formData = new FormData()
        // formData.append('file', dataSend.file)
    formData.append('cd_empresa', dataSend.cd_empresa)
    if(dataSend.file) formData.append('file', dataSend.file[0])
    if(dataSend.cd_pessoa_fisica) formData.append('cd_pessoa_fisica', dataSend.cd_pessoa_fisica)
    if(dataSend.nr_valor_aporte) formData.append('nr_valor_aporte', dataSend.nr_valor_aporte)
    if(dataSend.file_termo_adesao) formData.append('file_termo_adesao', dataSend.file_termo_adesao)
    if(dataSend.cd_titular) formData.append('cd_titular', dataSend.cd_titular)
    if(dataSend.ie_tipo_parentesco) formData.append('ie_tipo_parentesco', dataSend.ie_tipo_parentesco)
    
    return axios.post(
        `${ configs.baseUrl }/webcli/med-empresa-correntista/credenciar/`, formData,
        { headers: {'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }` } }
    )
        .then(response => response)
        .catch(configs.errorHandler)
}

const salvarRendimento = (dataSend) => GenericDAO.save(`/webcli/empresa/rendimento/`, dataSend)
const getRendimento = (id, params) => GenericDAO.find(`/webcli/empresa/rendimento/${ id }/`, params)
const statusAtualizacaoRendimento = (dataSend) => GenericDAO.save(`/webcli/empresa/rendimento/atualizacao/`, dataSend)

const findAllContrato = (params) => GenericDAO.find(`/webcli/med-empresa-contrato/`, params)

const listRevendedores = (dataSend) => GenericDAO.find(`/webcli/empresa-usuarios/`, dataSend)
const associarUsuario = (dataSend) => GenericDAO.save('/webcli/empresa/associar-cliente/', dataSend, { ignorarEstabelecimento: true })
const removerAssociado = (dataSend) => GenericDAO.save(`/webcli/empresa/remover-cliente/`, dataSend)
const listarAssociados = (params) => GenericDAO.find(`/webcli/empresa-associados/listar-correntistas/`, params)
const listarAssociadosCorrentista = (params) => GenericDAO.find(`/webcli/empresa-associados/listar-correntistas/`, params)
const historicoAssociado = (params) => GenericDAO.find(`/webcli/empresa/historico-correntista/`, params)

const addCreditos = (dataSend) => GenericDAO.save('/webcli/empresa/medcred/comprar/', dataSend)
const getSaldo = (params) => GenericDAO.find('/webcli/empresa/medcred/saldo/', params)

const getAgenda = (params) => GenericDAO.find('/webcli/empresa/agendamentos/', params)
const getExtrato = (params) => GenericDAO.find('/webcli/empresa/medcred/extrato/', params)
const pagarServicos = (dataSend) => GenericDAO.save('/medclub/empresa/caixa/', dataSend)
const getDados = (params) => GenericDAO.find('/webcli/empresa/dados/', params)

const getTiposEmpresa = (params) => GenericDAO.find('/webcli/tipo-empresa/', params)

const getUtilizacoes = (id, params) => GenericDAO.find(`/webcli/empresa/rendimento-utilizacoes/${ id }/`, params)

const getFaixas = (params) => GenericDAO.find(`/webcli/med-empresa-tabela-faixa/`, params)
const addFaixas = (params) => GenericDAO.save(`/webcli/med-empresa-tabela-faixa/`, params)

const getTitulosContratante = (params) => GenericDAO.find(`/webcli/contratante/titulos-gerados/`, params)
const saveTituloContratante = (dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    let formData = new FormData()
    Object.keys(dataSend).forEach((key) => { if (dataSend[key]) formData.append(`${key}`, dataSend[key]) })

    return axios.patch(
        `${ configs.baseUrl }/webcli/contratante/titulos-gerados/anexar-comprovante/`, formData,
        { headers: {'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }` } }
    )
        .then(response => response)
        .catch(configs.errorHandler)
}
const zerarSaldoAssociado = (id) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    const path = `/webcli/med-empresa-correntista/${id}/zerar-saldo/`
    return axios.patch(
        `${ configs.baseUrl }${path}`, {}, { headers: {
            'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }`
        }}
    )
        .then(response => response)
        .catch(configs.errorHandler)
}

export default {
    find,
    findAll,
    remove,
    save,
    listRevendedores,
    saveUsuario,
    pagarServicos,
    associarUsuario,
    getExtrato,
    addCreditos,
    getAgenda,
    getSaldo,
    listarAssociados,
    listarAssociadosCorrentista,
    removerAssociado,
    historicoAssociado,
    getDados,
    getTiposEmpresa,
    toggle_status,
    salvarRendimento,
    getRendimento,
    statusAtualizacaoRendimento,
    excluirCorrentista,
    adicionarCorrentista,
    getUtilizacoes,
    solicitarInclusaoCorrentista,
    solicitarExclusaoCorrentista,
    anexarTermo,
    buscarFaixa,
    getTitulosContratante,
    saveTituloContratante,
    historicoEmpresa,
    historicoCorrentista,
    saveContrato,
    findAllContrato,
    inativarCorrentista,
    listarSolicitacaoContratante,
    listarSolicitacaoContratanteMedclub,
    atualizarSolicitacaoContratanteMedclub,
    anexarComprovanteAprovarSolicitacao,
    adicionarCorrentistasArquivo,
    getFaixas,
    addFaixas,
    zerarSaldoAssociado,
}
